import { createContext } from "react";

import { TFeatures } from "@modules/features/types";

const FeatureContext = createContext<TFeatures>([]);

export default FeatureContext;
